import React, { useContext } from "react";
import Logo from "../../images/logo.webp";
import "./footer.css";
import { WebsiteContext } from "../../context/AppContext";
import { useNavigate } from "react-router-dom";
import { RiInstagramFill, RiYoutubeFill } from "react-icons/ri";
import { IoLogoGooglePlaystore } from "react-icons/io5";
import { FiArrowUp, FiArrowUpRight, FiHeart, FiMail } from "react-icons/fi";
import { TbSparkles } from "react-icons/tb";

const FooterComponent = () => {
  const { dark, handleRoute } = useContext(WebsiteContext);
  const navigate = useNavigate();

  const handleSocialRoute = (type) => {
    switch (type) {
      case "Youtube":
        window.open("https://www.youtube.com/@reena_english", "_blank");
        break;
      case "Instagram":
        window.open("https://www.instagram.com/english_with_reena/", "_blank");
        break;
      default:
        break;
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleFeatureClick = (id) => {
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 250);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className={`modern_footer ${dark ? "modern_footer_dark" : "modern_footer_light"}`}>
      <div className="footer_top_glow" />

      <div className="footer_inner">
        <div className="footer_grid">
          {/* Brand & App Info Column */}
          <div className="footer_brand_col">
            <div className="footer_brand_header" onClick={() => handleRoute("Home")}>
              <img src={Logo} alt="Fluent Fable Logo" className="footer_logo_img" />
              <div className="footer_brand_text">
                <span className="footer_brand_title">Fluent Fable</span>
                <span className="footer_brand_tagline">Smart AI English Companion</span>
              </div>
            </div>

            <div className="footer_slogan_badge">
              <span>Small Step 🤏</span>
              <span>•</span>
              <span>Big Change ✌️</span>
            </div>

            <p className="footer_description">
              Accelerate your English speaking fluency with curated daily AI insights, interactive grammar & vocabulary quizzes, and real-time conversational practice.
            </p>

            <div
              className="footer_playstore_btn"
              onClick={() => handleRoute("GettheApp")}
              title="Download Fluent Fable on Google Play"
            >
              <IoLogoGooglePlaystore className="footer_playstore_icon" />
              <div className="footer_playstore_text">
                <span className="footer_playstore_sub">Get It On</span>
                <span className="footer_playstore_title">Google Play</span>
              </div>
            </div>
          </div>

          {/* Core Features Column */}
          <div className="footer_col">
            <h4 className="footer_col_title">Features</h4>
            <ul className="footer_links_list">
              <li className="footer_link_item" onClick={() => handleFeatureClick("ai-insights")}>
                <TbSparkles size={14} style={{ color: "#ff7a18" }} />
                <span>Daily AI Insights</span>
              </li>
              <li className="footer_link_item" onClick={() => handleFeatureClick("interactive-quizzes")}>
                <span>Grammar & Vocab Quizzes</span>
              </li>
              <li className="footer_link_item" onClick={() => handleFeatureClick("ai-practice")}>
                <span>Conversational AI Practice</span>
              </li>
              <li className="footer_link_item" onClick={() => handleFeatureClick("learning-path")}>
                <span>Structured Learning Path</span>
              </li>
              <li className="footer_link_item" onClick={() => navigate("/razorpay/1")}>
                <span>1-Month Spoken English</span>
                <span className="footer_link_badge">Live</span>
              </li>
            </ul>
          </div>

          {/* Quick Links Column */}
          <div className="footer_col">
            <h4 className="footer_col_title">Company & Links</h4>
            <ul className="footer_links_list">
              <li className="footer_link_item" onClick={() => handleRoute("Home")}>
                <span>Home</span>
              </li>
              <li className="footer_link_item" onClick={() => handleRoute("About")}>
                <span>About Us</span>
              </li>
              <li className="footer_link_item" onClick={() => handleRoute("Blog")}>
                <span>Blogs & Guides</span>
              </li>
              <li className="footer_link_item" onClick={() => handleRoute("Contact")}>
                <span>Contact & Support</span>
              </li>
              <li className="footer_link_item" onClick={() => handleRoute("Terms_of_service")}>
                <span>Terms of Service</span>
              </li>
              <li className="footer_link_item" onClick={() => handleRoute("Privacy_policy")}>
                <span>Privacy Policy</span>
              </li>
            </ul>
          </div>

          {/* Community & Social Cards */}
          <div className="footer_col footer_community_col">
            <h4 className="footer_col_title">Community</h4>

            <div
              className="footer_social_card"
              onClick={() => handleSocialRoute("Youtube")}
              title="Visit our YouTube channel"
            >
              <div className="social_card_left">
                <div className="social_card_icon youtube">
                  <RiYoutubeFill />
                </div>
                <div className="social_card_meta">
                  <span className="social_card_title">YouTube</span>
                  <span className="social_card_stats">45.2K Subscribers</span>
                </div>
              </div>
              <FiArrowUpRight className="social_card_arrow" />
            </div>

            <div
              className="footer_social_card"
              onClick={() => handleSocialRoute("Instagram")}
              title="Follow us on Instagram"
            >
              <div className="social_card_left">
                <div className="social_card_icon instagram">
                  <RiInstagramFill />
                </div>
                <div className="social_card_meta">
                  <span className="social_card_title">Instagram</span>
                  <span className="social_card_stats">224K Followers</span>
                </div>
              </div>
              <FiArrowUpRight className="social_card_arrow" />
            </div>

           {/* <a
              href="mailto:fluentfable@gmail.com"
              className="footer_email_capsule"
              style={{ textDecoration: "none" }}
            >
              <FiMail size={15} />
              <span>fluentfable@gmail.com</span>
            </a>  */}
          </div>
        </div>

        {/* Bottom Bar Divider */}
        <div className="footer_bottom_divider" />

        {/* Bottom Bar */}
        <div className="footer_bottom_bar">
          <p className="footer_copyright_text">
            © {new Date().getFullYear()} Fluent Fable. Crafted with{" "}
            <FiHeart className="footer_heart_icon" /> for English learners worldwide.
          </p>

          <div className="footer_bottom_actions">
            <div className="footer_legal_links">
              <span className="footer_legal_link" onClick={() => handleRoute("Privacy_policy")}>
                Privacy
              </span>
              <span>•</span>
              <span className="footer_legal_link" onClick={() => handleRoute("Terms_of_service")}>
                Terms
              </span>
              <span>•</span>
              <span className="footer_legal_link" onClick={() => handleRoute("Contact")}>
                Help
              </span>
            </div>

            <button
              className="footer_scroll_top_btn"
              onClick={scrollToTop}
              title="Back to top"
              aria-label="Back to top"
            >
              <FiArrowUp />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;
